export default "__VITE_ASSET__DuFLuvvi__"